export function budgetReducer(state = "", {
    type,
    payload
}){
    
    switch(type){
        
        case "NEW_BUDGET":     
        case "UPDATE_BUDGET":     
            let list = Object.assign({}, state);
            payload.forEach( budget => {
                if (!list[budget.budget_year]) {
                    list[budget.budget_year] = {}
                }
                list[budget.budget_year][budget.category_id] = budget
            })
            return list
            
        case "GET_BUDGETS":
            let list2 = Object.assign({}, state);
            payload.forEach(item => {
                if (!list2[item.budget_year]) {
                    list2[item.budget_year] = {}
                }
                list2[item.budget_year][item.category_id] = item
            })
            return list2

        default:
            return state;
    }
    
}